import Vue from 'vue';
import Component from 'vue-class-component';
import BbModal from 'common/components/BbModal/BbModal.vue';
import ReminderLogo from 'assets/icons/reminder_logo.svg';
import OnboardingRegalendarioImg1 from 'assets/images/OnboardingRegalendarioImg1.svg';
import OnboardingRegalendarioImg2 from 'assets/images/OnboardingRegalendarioImg2.svg';

import useAccount from 'composables/useAccount';

@Component({
  components: {
    BbModal,
  },
  setup() {
    const { getUserData } = useAccount();
    return {
      user: getUserData,
    };
  },
})
export default class OnboardingRegalendarioModalComponent extends Vue {
  assets = {
    logo: ReminderLogo,
    img1: OnboardingRegalendarioImg1,
    img2: OnboardingRegalendarioImg2,
  };
  hasCreatedThreeReminders = this.user.has_created_three_reminders;

  redirectToProducts() {
    this.$router.push({ name: 'products' });
  }
}
